define('app/controllers/main',['angular', 'app/services/shared'], function (angular) {
  var module = angular.module('app.main', ['app.shared'])

  // routing
  module.config(['$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/', {
        templateUrl: 'templates/main.html',
        controller: 'MainController'
      }).when('/main', {
        templateUrl: 'templates/main.html',
        controller: 'MainController'
      })
    }
  ])

  module.controller('MainController', [
    '$rootScope',
    '$scope',
    '$http',
    '$route',
    '$compile',
    '$location',
    'sharedProperties',
    function ($rootScope, $scope, $http, $route, $compile, $location, sharedProperties) {
      $scope.updating = false

      $scope.doLogout = function () {
        $http.get('/auth/logout').then(function (response) {
          $rootScope.userName = null;
          $location.url('/login');
        })
      };

      $scope.openPath = function (path) {
        $location.url(path)
      }

    }
  ])
  return module
})
;
